import { useTranslation } from 'react-i18next';
import { DeviceClass, DeviceType, Upload, DeviceFamily } from 'shared/models';
import { UpdateSoftwareCommand } from 'logic/deviceScriptParser';
import { sortNames } from 'logic/sortNames';

export type Props = {
    index: number;
    command: UpdateSoftwareCommand;
    deviceType: DeviceType | null;
    uploads: Record<string, Upload> | null;
    onClickSoftware(filename: string): void;
    onClickForce(force: boolean): void;
};

export const UpdateSoftwareCommandOptions = ({ index, command, deviceType, uploads, onClickSoftware, onClickForce }: Props) => {
    const { t } = useTranslation();

    const eligibleUploads =
        uploads && deviceType
            ? Object.keys(uploads)
                .filter(filename =>
                    (deviceType.deviceClass === DeviceClass.Display && (
                        (
                            deviceType.deviceCapabilities.TTG
                            && filename.toLowerCase().indexOf('.upg') >= 0
                        )
                        || (
                            deviceType.deviceFamily === DeviceFamily.MatisseR4 && (
                                filename.toLowerCase().indexOf('.tar') >= 0
                            )
                        )
                        || (
                            deviceType.deviceFamily === DeviceFamily.MatisseR5 && (
                                filename.toLowerCase().indexOf('.mpack') >= 0
                            )
                        )
                    ))
                    || (deviceType.deviceClass === 'gateway' && /^RtcGateway.*\.zip$/i.test(filename))
                    || (deviceType.deviceClass === 'lobbypanel' && /^LobbyPanel.*\.msi$/i.test(filename))
                )
                .sort(sortNames)
            : [];

    return (
        <span className="update-software-command-options">
            <span className="ui compact menu">
                <div className="ui simple dropdown item">
                    { command.filename ||
                        <span style={ { opacity: .5 } }>
                            { t('DEVICE.COMMANDS.NONE_SELECTED') }
                        </span>
                    }
                    <i className="dropdown icon"/>
                    <div className="menu">
                        { eligibleUploads.map((u: string) =>
                            <div
                                key={ u }
                                className="item"
                                onClick={ () => onClickSoftware(u) }
                            >
                                { u }
                            </div>
                        ) }
                    </div>
                </div>
            </span>
            <input
                className="ui checkbox"
                type="checkbox"
                id={ `update-software-${index}-force` }
                checked={ command.force }
                disabled={ !command.filename }
                onChange={ () => onClickForce(!command.force) }
                style={ {
                    verticalAlign: 'middle',
                    margin: '0 .5em 0 1.5em',
                } }
            />
            <label htmlFor={ `update-software-${index}-force` }>
                { t('DEVICE.COMMANDS.FORCE') }
            </label>
        </span>
    );
};
